export default __webpack_public_path__ + "static/revolta-9ea949ff6c91ccaf3fabc13a0370dc42.webp";